const fields = [
  {
    name: "usdPrice",
    label: "USD Price",
    type: "number",
    validationType: "number",
  },
  {
    name: "euroPrice",
    label: "Euro Pice",
    type: "number",
    validationType: "number",
  },
  {
    name: "toleranceOfExchange",
    label: "Tolerance Of Exchange",
    type: "number",
    validationType: "number",
  },
];

export default fields;
